<template>
  <div class="pcard" role="dialog" aria-label="Карточка дополнительной точки">
    <div class="pcard__head">
      <div>
        <div class="pcard__name">{{ point.name || '—' }}</div>
        <div class="pcard__group">
          <span class="pcard__diamond" :style="{ background: color }"></span>{{ group ? (group.title || '—') : 'Без группы' }}
        </div>
      </div>
      <button type="button" class="btn btn-sm btn-light pcard__close" aria-label="Закрыть" @click="$emit('close')">×</button>
    </div>
    <div class="pcard__row"><span class="text-muted">Адрес:</span> {{ point.address || 'Адрес не указан' }}</div>
    <div class="pcard__row"><span class="text-muted">Координаты:</span> {{ coords }}</div>
    <div v-if="point.description" class="pcard__row">{{ point.description }}</div>
    <div class="pcard__actions">
      <button type="button" class="btn btn-sm btn-success pcard__edit" :disabled="busy" @click="$emit('edit', point)">Изменить</button>
      <button type="button" class="btn btn-sm btn-outline-danger pcard__delete" :disabled="busy" @click="$emit('delete', point)">Удалить</button>
    </div>

    <CardTaskBlock
      class="pcard__tasks"
      :target="point"
      :active-task="activeTask"
      :extra-active-count="extraActiveCount"
      :tasks-state="tasksState"
      :can-create="!activeTask && !tasksUnavailable"
      :busy="busy"
      @create-task="$emit('create-task', $event)"
      @edit-task="$emit('edit-task', $event)"
      @cancel-task="$emit('cancel-task', $event)"
      @show-active-tasks="$emit('show-active-tasks')"
    />
  </div>
</template>

<script>
import CardTaskBlock from '@/components/management/dispatcher/map/CardTaskBlock.vue';
import { groupColor, toLatLng } from '@/components/management/dispatcher/objectState';

export default {
  name: 'PointCard',
  components: { CardTaskBlock },
  props: {
    point: { type: Object, required: true },
    group: { type: Object, default: null },
    // Same task props as ObjectCard (spec §9); a custom point carries no `last_assigned_task`,
    // so the active list alone decides between the task block and «Создать задачу».
    activeTask: { type: Object, default: null },
    extraActiveCount: { type: Number, default: 0 },
    tasksUnavailable: { type: Boolean, default: false },
    tasksState: { type: String, default: 'ready' },
    busy: { type: Boolean, default: false },
  },
  computed: {
    color() { return groupColor(this.group); },
    coords() {
      const ll = toLatLng(this.point);
      return ll ? `${ll[0]}, ${ll[1]}` : '—';
    },
  },
};
</script>

<style scoped lang="scss">
.pcard {
  width: 320px; background: #fff; border-radius: 12px; box-shadow: 0 10px 30px rgba(20, 24, 20, .18);
  padding: 14px 16px; font-size: 13px; display: flex; flex-direction: column; gap: 8px;
}
.pcard__head { display: flex; justify-content: space-between; align-items: flex-start; gap: 8px; }
.pcard__name { font-weight: 800; font-size: 15px; }
.pcard__group { display: flex; align-items: center; gap: 8px; color: #8b918c; font-size: 12px; }
.pcard__diamond { width: 11px; height: 11px; transform: rotate(45deg); display: inline-block; }
.pcard__actions { display: flex; gap: 8px; margin-top: 4px; }
.pcard__tasks { border-top: 1px solid #eceee9; padding-top: 10px; margin-top: 2px; }
</style>
